<button class="button is-primary" mat-button (click)="toggleDarkMode()" [ngClass]="{'is-outlined': !darkMode}">Dark mode</button>